import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import OrderExpiredSection from '../../../paymentJourney/OrderExpiredSection/OrderExpiredSection';

export function OrderExpiredView({ t, siteHeader }) {
  const { meta: { title: metaTitle } = {}, data: { title: dataTitle } = {} } =
    siteHeader || {};
  const title = metaTitle || dataTitle;
  const helmetTitle = title
    ? `${t('event.purchase.payment-expired')} | ${title}`
    : t('event.purchase.payment-expired');

  return (
    <SiteLayout
      helmet={{ title: helmetTitle }}
      footerUpperHidden
      style={{ backgroundColor: '#fff' }}
    >
      <OrderExpiredSection />
    </SiteLayout>
  );
}

OrderExpiredView.propTypes = {
  siteHeader: PropTypes.shape({
    data: PropTypes.shape({
      title: PropTypes.string,
    }),
    meta: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    siteHeader: state.siteHeader,
  };
}

export default withTranslation()(connect(mapStateToProps)(OrderExpiredView));
